import ActiveBadge from './ActiveBadge'

export default ActiveBadge
